import { css } from 'styled-components';
import token from 'styled-token';
import { StyledIcon } from '../../components/Icon/Icon.styles';

/** @class AvatarBadgeMixin */
/** @method */
export var AvatarBadgeMixin = function AvatarBadgeMixin(props) {
  var size = props.size;
  return token({
    badgeSize: "AvatarBadge.badgeSizes." + size,
    backgroundColor: 'AvatarBadge.backgroundColor',
    borderRadius: 'AvatarBadge.borderRadius',
    borderColor: 'AvatarBadge.borderColor',
    borderWidth: 'AvatarBadge.borderWidth',
    color: 'AvatarBadge.foregroundColor',
    iconSize: "AvatarBadge.iconSizes." + size
  }, function (_ref) {
    var backgroundColor = _ref.backgroundColor,
      badgeSize = _ref.badgeSize,
      borderColor = _ref.borderColor,
      borderRadius = _ref.borderRadius,
      borderWidth = _ref.borderWidth,
      color = _ref.color,
      iconSize = _ref.iconSize;
    return css(["height:", "px;width:", "px;box-sizing:border-box;background-color:", ";border-radius:", ";border:", " solid ", ";color:", ";display:flex;justify-content:center;align-items:center;", "{height:", "px;width:", "px;}"], badgeSize, badgeSize, backgroundColor, borderRadius, borderWidth ? borderWidth + "px" : '2px', borderColor, color, StyledIcon, iconSize, iconSize);
  })(props);
};